/**
 * @module Experience/repdash
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { LineSummary } from '@support/api/proxies/responses/api-2006.interface';
import { LINE_REP_ACTIONS_COMPONENTS } from '@experience/landing/common/constants/line-rep-actions.constants';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountLandingService } from '@experience/landing/common/components/account-landing/services/account-landing.service';
import { PERMISSION_CONSTANTS } from '@support/shared/constants/permission.constants';
import { UIPermissionService } from '@support/shared/widgets/services/ui-permission.service';
import { ROUTER_CONSTANTS } from '../../constants/line-details.constants';

@Component({
  selector: 'tmo-line-device',
  templateUrl: './line-device.component.html',
  styleUrls: [
    '../../../../../../style-sheets/components/html-accordion.component.scss',
    '../../../../../../style-sheets/components/html-blade-links.component.scss',
  ],
})
export class LineDeviceComponent implements OnInit, OnDestroy {
  /*
   * Boolean to check if line is Active
   */
  public isChangeMsisdnEligible: boolean;
  /**
   * stores permission value
   */
  public permissionEnabled: boolean;
  /*
   * AEM content data
   */
  @Input() public contentData: ConfigData;
  /*
   * line Details data
   */
  @Input() public lineDetails: LineSummary;

  @Input() public selectedMsisdn: string;
  /**
   * Holds boolean for tourist plan
   */
  @Input() public isTouristPlan: boolean;

  constructor(
    private stateStoreUtilsService: StateStoreUtilsService,
    private router: Router,
    public routeSnapshot: ActivatedRoute,
    private permissionService: UIPermissionService,
    protected accountLandingService: AccountLandingService
  ) {
    this.isChangeMsisdnEligible = false;
  }

  /**
   * Initialises the configuration of line device component
   * @returns void
   */
  public ngOnInit(): void {
    this.permissionEnabled = this.permissionService.checkPermissions(
      ROUTER_CONSTANTS.LINE_LANDING,
      PERMISSION_CONSTANTS.MSISDN_CHANGE
    );
    if (this.lineDetails.lineStatus === LINE_REP_ACTIONS_COMPONENTS.ACTIVE) {
      this.isChangeMsisdnEligible = true;
    }
  }
  public ngOnDestroy(): void {}
  /**
   * Method for device page on support landing.
   * @returns void
   */
  public onClick(): void {
    this.stateStoreUtilsService.setRouteToDevice(true);
    this.router.navigate(['/support-landing']);
  }
  /**
   * Method for change msisdn entry point.
   * @returns void
   */
  public onChangePhoneNumber(): void {
    this.stateStoreUtilsService.setSelectedChangeMsisdn(this.selectedMsisdn);
    this.stateStoreUtilsService.setPreviousUrl(this.router.url);
    this.router.navigate(['/change-msisdn']);
  }
}
